import { get, find, compact, upperCase, isUndefined } from 'lodash-es';
import { getState } from './address';
import { getScriptCache } from './script-cache';
var GOOGLE_MAP_API_BASE_URL = 'https://maps.google.com/maps/api/js';
export var loadGoogleApi = function loadGoogleApi(apiKey) {
  return new Promise(function (resolve, reject) {
    var scriptCache = getScriptCache();
    var gScript = scriptCache.get('google');
    var params = {
      key: apiKey,
      libraries: ['places']
    };
    var paramString = Object.keys(params).map(function (key) {
      return "".concat(key, "=").concat(params[key]);
    }).join('&');
    var url = "".concat(GOOGLE_MAP_API_BASE_URL, "?").concat(paramString);
    if (isUndefined(gScript)) {
      gScript = scriptCache.add('google', url);
      if (isUndefined(gScript)) {
        return reject('Can not be added outside the browser environment');
      }
    }
    return gScript.onLoad.then(resolve)["catch"](reject);
  });
};
export function getComponent(components, types) {
  var longName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return get(find(components, function (component) {
    return types.every(function (type) {
      return component.types.includes(type);
    });
  }), longName ? 'long_name' : 'short_name');
}
export function convertToAddress(components) {
  var res = {
    city: getComponent(components, ['locality', 'political']),
    state: getState(getComponent(components, ['administrative_area_level_1', 'political'])),
    zipCode: getComponent(components, ['postal_code']),
    county: getComponent(components, ['administrative_area_level_2', 'political']),
    country: getComponent(components, ['country', 'political'])
  };
  res.street1 = compact([getComponent(components, ['street_number']), getComponent(components, ['route'])]).join(' ');
  res.street2 = upperCase(getComponent(components, ['subpremise']));
  return res;
}